<template>
  <div>
    <v-stepper v-model="e1">
      <v-stepper-header>
        <v-stepper-step color="amber" :complete="e1 > 1" step="1" @click="el = 1">Words</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step color="amber" :complete="e1 > 2" step="2" @click="el = 2">Images</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step color="amber" step="3" @click="el = 3">Arrange</v-stepper-step>
        <v-divider></v-divider>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <v-row>
            <v-col cols="6">
              <h2 v-text="copy('step1.title')"></h2>
            </v-col>
            <v-col cols="6">
              <p v-for="(item, index) in copy('step1.description')" :key="index" v-text="item" />
            </v-col>
          </v-row>

          <v-row dense v-if="gridView && words.length >= 1" class="mb-10">
            <!-- <v-col v-for="card in words" :key="card.id" :cols="2"> -->
            <div v-for="card in words" :key="card.id" :style="{ width: computedZoom }">
              <v-card class="mx-auto card" :data-id="card.id"
                :class="{ selected: card.selected, smaller: computedZoomClass }" @click="selectCard(card.id)"
                :hover="true" :elevation="1">
                <div class="card__inner" v-if="card.type == 'Word'">
                  <div class="card__inner__text">
                    <h2>{{ card.title }}</h2>
                  </div>
                </div>
                <div class="card__inner" :style="{ backgroundImage: `url(${card.src})` }" v-if="card.type == 'Image'">
                </div>
                <v-icon class="chk" v-if="card.selected">mdi-check</v-icon>
              </v-card>
            </div>
            <!-- </v-col> -->
          </v-row>

          <v-carousel height="60vh" cycle hide-delimiters v-else-if="words && words.length >= 1"
            class="align-center mb-10">
            <v-carousel-item v-for="card in words" :key="card.id">
              <v-card class="mx-auto mb-2 card" :data-id="card.id" :class="{ selected: card.selected }"
                @click="selectCard(card.id)" :elevation="10" :hover="true">
                <div class="card__inner" v-if="card.type == 'Word'">
                  <div class="card__inner__text">
                    <h2>{{ card.title }}</h2>
                  </div>
                </div>
                <div class="card__inner" :style="{ backgroundImage: `url(${card.src})` }" v-if="card.type == 'Image'">
                </div>
                <v-icon class="chk" v-if="card.selected">mdi-check</v-icon>
              </v-card>
            </v-carousel-item>
          </v-carousel>

          <bottom-navigation :save="false" :next="true" :prev="false" :gridView="true" :gridToggle="false"
            @save="saveExercise" @prev="prevStep" @next="nextStep" v-model="zoom">
            <p class="no-margin">
              Selected words
              <v-chip :class="wordsCheck" class="white--text">{{
                selectedWords.length
                }}</v-chip>
            </p>
          </bottom-navigation>
        </v-stepper-content>

        <v-stepper-content step="2">
          <v-row>
            <v-col cols="6">
              <h2 v-text="copy('step2.title')"></h2>
            </v-col>
            <v-col cols="6">
              <p v-for="(item, index) in copy('step2.description')" :key="index" v-text="item" />
              <p>Your selected words</p>
              <v-chip v-for="word in selectedWords" :key="word.title" class="white black--text mx-1">{{ word.title
                }}</v-chip>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6"> </v-col>
            <v-col cols="6">
              <v-select :items="dropdownCategories" v-model="filters" @change="changeFilter"></v-select>
            </v-col>
          </v-row>

          <v-row dense v-if="gridView" class="mb-10">
            <!-- <v-col v-for="card in images" :key="card.id" :cols="2"> -->
            <div v-for="card in images" :key="card.id" :style="{ width: computedZoom }">
              <v-card class="mx-auto card" :data-id="card.id" :class="{ selected: card.selected }"
                @click="selectCard(card.id)">
                <div class="card__inner" v-if="card.type == 'Word'">
                  <div class="card__inner__text">
                    <h2>{{ card.title }}</h2>
                  </div>
                </div>
                <div class="card__inner" v-if="card.type == 'Image'">
                  <Imgx :src="card.src" />
                </div>

                <v-icon class="chk" v-if="card.selected">mdi-check</v-icon>
              </v-card>
            </div>
            <!-- </v-col> -->
          </v-row>

          <v-carousel height="60vh" cycle hide-delimiters v-else class="align-center">
            <v-carousel-item v-for="card in images" :key="card.id" class="mb-10">
              <v-card class="mx-auto mb-2 card" :data-id="card.id" :class="{ selected: card.selected }"
                @click="selectCard(card.id)" :elevation="10">
                <div class="card__inner" v-if="card.type == 'Word'">
                  <div class="card__inner__text">
                    <h2>{{ card.title }}</h2>
                  </div>
                </div>
                <!-- <div
									class="card__inner"
									:style="{ backgroundImage: `url(${card.src})` }"
									v-if="card.type == 'Image'"
								></div> -->
                <div class="card__inner" v-if="card.type == 'Image'">
                  <Imgx :src="card.src" />
                  <!-- <ix-img class="imgix" :src="card.src" sizes="30vw" /> -->
                </div>
                <v-icon class="chk" v-if="card.selected">mdi-check</v-icon>
              </v-card>
            </v-carousel-item>
          </v-carousel>

          <bottom-navigation :save="true" :next="true" :prev="true" :gridView="true" :gridToggle="false"
            @save="saveExercise" @prev="prevStep" @next="nextStep" v-model="zoom">
            <p class="no-margin">
              Selected images
              <v-chip :class="imagesCheck" class="white--text">{{
                selectedImages.length
                }}</v-chip>
            </p>
          </bottom-navigation>
        </v-stepper-content>

        <v-stepper-content step="3">
          <v-row dense>
            <v-col cols="6">
              <h2 v-text="copy('step3.title')"></h2>
              <p v-for="(item, index) in copy('step3.description')" :key="index" v-text="item" />
            </v-col>
          </v-row>

          <draggable :list="shortlist" :sort="true" class="row" v-if="exercise && shortlist.length" ghost-class="ghost"
            @start="startDrag()" @end="endDrag()" ref="tiles" id="tiles">
            <div v-for="card in shortlist" :key="card.id" :data-id="card.id" :style="{ width: computedWidh }">
              <show-card :card="card"></show-card>
            </div>
          </draggable>

          <bottom-navigation :save="true" :next="false" :prev="true" :gridView="true" :gridToggle="false"
            @save="saveExercise" @prev="prevStep" @next="nextStep" v-model="cols">
          </bottom-navigation>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

    <v-dialog v-model="dialog" max-width="290">
      <v-card>
        <v-card-title class="headline">{{
          copy('saved.title')
          }}</v-card-title>

        <v-card-text>{{ copy('saved.description') }} </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="amber" text @click="dialog = false">
            Close
          </v-btn>

          <v-btn color="amber accent-1" text to="/users/dashboard">
            Back to Dashboard
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import lodash from "lodash";
import { store } from "@/store";
import draggable from "vuedraggable";
import { BottomNavigation, ShowCard, Imgx } from "@/components/core";
const fb = require("@/firebaseConfig.js");
export default {
  name: "BrandTiles",
  async created() {
    // GET request using fetch with async/await
    try {
      const response = await fetch(`/content/${this.$route.params.id}.json`);
      // No content file for this project: fall back to the en.json copy
      this.content = response.ok ? await response.json() : null;
    } catch (e) {
      this.content = null;
    }
  },
  data() {
    return {
      content: null,
      exercise: null,
      dragging: false,
      list: null,
      shortlist: [],
      e1: 1,
      gridView: true,
      cols: 4,
      zoom: 7,
      rows: 4,
      filters: "All",
      dialog: false,
      dropdownCategories: [
        "All",
        "Colour",
        "Illustration",
        "Pattern",
        "Photography",
        "Typography",
        "Selected",
      ],
    };
  },
  components: {
    draggable,
    ShowCard,
    BottomNavigation,
    Imgx,
  },
  computed: {
    ...mapState(["userProfile", "currentUser", "tiles", "currentProjectModel"]),
    disallowArabic() {
      return !!(
        this.content &&
        this.content.exercise_brand_tiles &&
        this.content.exercise_brand_tiles.disallow_arabic
      );
    },
    computedWidh() {
      switch (this.cols) {
        case 1:
          return "100%";
        case 2:
          return "50%";
        case 3:
          return "33.33%";
        case 4:
          return "25%";
        case 5:
          return "20%";
        case 6:
          return "16.666666666666667%";
        case 7:
          return "14.285714285714286%";
        case 8:
          return "12.5%";
        case 9:
          return "11.111111111111111%";
        case 10:
          return "10%";
        default:
          return "25%";
      }
    },
    computedZoom() {
      switch (this.zoom) {
        case 10:
          return "100%";
        case 9:
          return "50%";
        case 8:
          return "33.33%";
        case 7:
          return "25%";
        case 6:
          return "20%";
        case 5:
          return "16.666666666666667%";
        case 4:
          return "14.285714285714286%";
        case 3:
          return "12.5%";
        case 2:
          return "11.111111111111111%";
        case 1:
          return "10%";
        default:
          return "25%";
      }
    },
    computedZoomClass() {
      switch (this.zoom) {
        case 10:
          return "";
        case 9:
          return "";
        case 8:
          return "";
        case 7:
          return "";
        case 6:
          return "";
        case 5:
          return "smaller";
        case 4:
          return "smaller";
        case 3:
          return "smaller";
        case 2:
          return "smaller";
        case 1:
          return "smaller";
        default:
          return "smaller";
      }
    },
    computedRows() {
      return Math.ceil(this.shortlist.length / this.cols);
    },
    computedCells() {
      return this.cols * this.computedRows;
    },
    wordsCheck() {
      return this.selectedWords.length > 4 ? "red" : "grey darken-2";
    },
    imagesCheck() {
      return this.selectedImages.length > 16 ? "red" : "grey darken-2";
    },
    words() {
      if (this.list && this.list.length) {
        let list = this.list.filter((item) => item.type == "Word");
        return lodash.orderBy(list, "title", "asc");
      } else {
        return [];
      }
    },
    images() {
      if (this.list) {
        let arr = this.list.filter((item) => item.type == "Image");
        if (this.disallowArabic) {
          arr = arr.filter((x) => !x.arabic);
        }
        if (this.filters == "All") {
          return lodash.orderBy(arr, "id", "asc");
        } else if (this.filters == "Selected") {
          let filtered = this.shortlist.filter((item) => item.type == "Image");
          return lodash.orderBy(filtered, "title", "desc");
        } else {
          const filteredArr = arr.filter(
            (item) => item.category === this.filters
          );
          return lodash.orderBy(filteredArr, "id", "desc");
        }
      } else {
        return [];
      }
    },
    selectedImages() {
      if (this.shortlist) {
        let filtered = this.shortlist.filter((item) => item.type == "Image");
        return lodash.orderBy(filtered, "title", "desc");
      } else {
        return [];
      }
    },
    selectedWords() {
      if (this.shortlist) {
        const list = this.shortlist.filter((item) => item.type == "Word");
        return list.length >= 1 ? list : [];
      } else {
        return [];
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.currentUser && this.currentUser.uid) {
        this.loadTiles();
      } else {
        this.$router.navigateTo("login");
      }
    });
  },
  beforeRouteUpdate(to, from, next) {
    this.$nextTick(() => {
      this.loadTiles();
    });
    next();
  },
  methods: {
    copy(path) {
      const value = lodash.get(this.content, `exercise_brand_tiles.${path}`);
      return value !== undefined
        ? value
        : this.$t(`${this.$route.meta.content}.${path}`);
    },
    nextStep() {
      this.e1++;
      this.saveExercise(false);
    },
    prevStep() {
      this.e1--;
      this.saveExercise(false);
    },
    startDrag() {
      this.dragging = true;
    },
    endDrag() {
      let count = 0;
      let vm = this;
      let div = document.getElementById("tiles");
      div.children.forEach((doc) => {
        let item = this.shortlist.find((x) => x.id === doc.dataset.id);
        let indexOfItem = this.shortlist.indexOf(item);
        item.index = count;
        vm.$set(vm.shortlist, indexOfItem, item);
        count++;
      });
      // this.saveExercise();
      this.dragging = false;
    },
    createShortlist() {
      let l = this.list.filter((item) => item.selected == true);
      this.shortlist = lodash.orderBy(l, "index", "asc");
    },
    loadShortlist() {
      if (this.exercise) {
        this.shortlist = this.exercise.selectedTiles;
      } else {
        this.shortlist = this.list.filter((item) => item.selected == true);
      }
    },
    updateShortList(item) {
      if (item.selected == true) {
        item.index = this.shortlist.length;
        this.shortlist.push(item);
      } else {
        let ref = this.shortlist.find((x) => x.id === item.id);
        let indexOfItem = this.shortlist.indexOf(ref);
        this.shortlist.splice(indexOfItem, 1);
      }
      this.saveExercise(false);
    },
    createList() {
      let list = this.tiles;
      let count = 0;
      list.forEach((item) => {
        item.selected = this.checkId(item.id);
        item.index = count;
        count++;
      });
      this.list = list;
      this.createShortlist();
    },
    loadTiles() {
      if (this.tiles.length === 0) {
        fb.tilesCollection
          .orderBy("createdOn", "desc")
          .onSnapshot((querySnapshot) => {
            let items = [];
            querySnapshot.forEach((doc) => {
              let post = doc.data();
              items.push(post);
            });
            store.commit("setTiles", items);
            this.getExercise();
          });
      } else {
        this.getExercise();
      }
    },
    checkId(id) {
      if (this.exercise) {
        let filteredList = this.exercise.selectedTiles.filter(
          (item) => item.id == id
        );
        return filteredList.length >= 1 ? true : false;
      } else {
        return false;
      }
    },
    selectCard(id) {
      let vm = this;
      let item = this.list.find((item) => item.id === id);
      let indexOfItem = this.list.indexOf(item);
      let truthy = item.selected;
      item.selected = !truthy;
      vm.$set(vm.list, indexOfItem, item);
      this.updateShortList(item);
    },
    getExercise() {
      // get a ref to the exercise and listen to changes
      let ref = fb[this.$route.meta.model]
        .where("uid", "==", `${this.currentUser.uid}`)
        .where("pid", "==", this.currentProjectModel.id);
      ref.onSnapshot((querySnapshot) => {
        let items = [];
        querySnapshot.forEach((doc) => {
          let post = doc.data();
          items.push(post);
        });
        this.exercise = items[0];
        console.log("loaded items", items);
        this.createList();
        this.loadShortlist();
      });
    },
    saveExercise(notify) {
      // check if exercise exists
      let ref;
      let vm = this;
      if (this.exercise == null) {
        ref = fb[this.$route.meta.model].doc();
      } else {
        ref = fb[this.$route.meta.model].doc(this.exercise.id);
      }
      ref
        .set({
          updatedOn: new Date(),
          id: ref.id,
          uid:
            this.currentUser && this.currentUser.uid
              ? this.currentUser.uid
              : "unknown",
          pid:
            this.currentProjectModel && this.currentProjectModel.id
              ? this.currentProjectModel.id
              : "unknown",
          selectedTiles: this.shortlist,
          cols: this.cols,
        })
        .then(() => {
          if (notify) {
            vm.dialog = true;
          }
        })
        .catch((error) => {
          alert("Error adding document: ", error);
        });
    },
    changeFilter(val) {
      this.filters = val;
      // this.getFilteredItems();
    },
  },
};
</script>

<style lang="scss">
.canvas {
  position: relative;
  width: 100%;
  height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: grey;

  &__tile {
    width: 200px;
    height: 200px;
    background-size: cover;
    background-position: center;
    margin: 2px;
  }
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
</style>
